<template>
  <template v-if="client && displayVariant === 'sidebar'">
    <div class="client-card border client-card--sidebar" :class="cardClasses">
      <div class="client-card__panel client-card__panel--sidebar">
        <div class="client-card__sidebar-title">
          <div
            class="fs-7 fw-bolder text-gray-700 line-clamp"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="clientTitle"
          >{{ clientTitle }}</div>
          <div
            v-if="hasPodftError"
            class="fs-8 text-danger opacity-75"
          >{{ client.podft.message }}</div>
          <div
            v-else
            class="fs-8 text-gray-500"
          >
            <span v-if="module.Modal.infoCard('iin')">{{ client.client.iin ? formattedIin : client.document?.number }}</span>
            <span v-if="module.Modal.infoCard('person')"> · {{ client.filter.person ? 'ФЛ' : 'ЮЛ' }}</span>
            <span v-if="module.Modal.infoCard('resident')"> · {{ client.filter.resident ? 'Рез.' : 'Нерез.' }}</span>
            <span v-if="module.Modal.infoCard('class') && client.class"> · Класс: <b class="text-gray-600" v-html="client.class.title"></b></span>
            <span v-if="module.Modal.infoCard('pensioner') && client.client?.pensioner" > · Льгота</span>
          </div>
        </div>
      </div>
    </div>
  </template>

  <template v-else-if="client && displayVariant === 'default'">
    <div class="client-card border" :class="cardClasses">
      <div class="client-card__panel">
        <i
          class="ki-duotone ki-security-user fs-md-3x fs-5x"
          :class="[
            hasPodftError
              ? 'text-danger'
              : (client.filter.person ? 'text-primary' : 'text-warning'),
            isBeingVerify ? 'opacity-0' : ''
          ]"
        >
          <i class="path1"></i>
          <i class="path2"></i>
        </i>
        <i
          v-if="isBeingVerify"
          class="ki-duotone ki-abstract-33 fs-md-3x fs-5x text-primary verified opacity-50"
        >
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <div class="ms-4">
          <div
            class="fs-6 fw-bolder text-gray-700 line-clamp"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="clientTitle"
          >{{ clientTitle }}</div>
          <template v-if="hasPodftError">
            <div class="fs-8 text-danger opacity-75">{{ client.podft.message }}</div>
          </template>
          <template v-else>
            <div v-if="isBeingVerify" class="fs-8 text-primary opacity-75">Проверка документов</div>
            <div v-else class="fs-8 text-gray-400">
              <span v-if="module.Modal.infoCard('iin')">
                {{ client.client.iin ? formattedIin : client.document?.number }} /
              </span>
              <span v-if="module.Modal.infoCard('person')" class="text-primary opacity-75">{{ personTypeLabel }}</span> /
              <span v-if="module.Modal.infoCard('resident')" class="text-danger opacity-75">{{ residentTypeLabel }}</span>
              <slot name="additional"></slot>
              <span v-if="module.Modal.infoCard('class') && client.class"> / Класс: <b class="text-gray-600" v-html="client.class.title"></b></span>
              <span v-if="module.Modal.infoCard('pensioner') && client.client?.pensioner"> / <span class="text-success">Льгота</span></span>
            </div>
          </template>
        </div>
        <div v-if="!changeDisabled" class="card_change">
          <span
            v-if="hasPodftError"
            class="restart-item"
            title="Повторить проверку"
            @click="$emit('retry-verify')"
          >
            <i class="ki-outline ki-arrows-circle fs-3"></i>
          </span>
          <slot name="change"></slot>
        </div>
      </div>
      <slot v-if="!changeDisabled" name="footer"></slot>
    </div>
  </template>

  <template v-else-if="client && displayVariant === 'wide'">
    <div class="client-card client-card--bpm-wide border" :class="cardClasses">
      <div class="client-card__panel client-card__panel--wide">
        <div class="client-card__icon position-relative">
          <i
            class="ki-duotone ki-security-user fs-md-3x fs-5x"
            :class="[
              hasPodftError
                ? 'text-danger'
                : (client.filter.person ? 'text-primary' : 'text-warning'),
              isBeingVerify ? 'opacity-0' : ''
            ]"
          >
            <i class="path1"></i>
            <i class="path2"></i>
          </i>
          <i
            v-if="isBeingVerify"
            class="ki-duotone ki-abstract-33 fs-md-3x fs-5x text-primary verified opacity-50"
          >
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
        <div
          class="client-card__title fs-6 fw-bolder text-gray-700 line-clamp"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="clientTitle"
        >{{ clientTitle }}</div>
        <div
          v-if="hasPodftError"
          class="client-card__meta fs-8 text-danger opacity-75"
        >{{ client.podft.message }}</div>
        <div
          v-else-if="isBeingVerify"
          class="client-card__meta fs-8 text-primary opacity-75"
        >Проверка документов</div>
        <div
          v-else
          class="client-card__meta fs-8 text-gray-400"
        >
          <span v-if="module.Modal.infoCard('iin')">
            {{ client.client.iin ? formattedIin : client.document?.number }} /
          </span>
          <span v-if="module.Modal.infoCard('person')" class="text-primary opacity-75">{{ personTypeLabel }}</span> /
          <span v-if="module.Modal.infoCard('resident')" class="text-danger opacity-75">{{ residentTypeLabel }}</span>
          <slot name="additional"></slot>
          <span v-if="module.Modal.infoCard('class') && client.class"> / Класс: <b class="text-gray-600" v-html="client.class.title"></b></span>
          <span v-if="module.Modal.infoCard('pensioner') && client.client?.pensioner"> / <span class="text-success">{{ pensionerLabel }}</span></span>
        </div>
        <div v-if="!changeDisabled" class="client-card__extras">
          <slot name="footer"></slot>
        </div>
        <div v-if="!changeDisabled" class="client-card__actions card_change">
          <span
            v-if="hasPodftError"
            class="restart-item"
            title="Повторить проверку"
            @click="$emit('retry-verify')"
          >
            <i class="ki-outline ki-arrows-circle fs-3"></i>
          </span>
          <slot name="change"></slot>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
export default {
  name: 'CustomerBpmCard',
  props: {
    client: {
      type: Object,
      default: null
    },
    changeDisabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['sidebar', 'default', 'wide'].includes(value)
    },
    module: {
      type: Function,
      required: true
    },
    mode: {
      type: [Object, Function],
      required: true
    },
  },
  emits: ['retry-verify'],
  data() {
    return {
      isMobileViewport: false
    }
  },
  computed: {
    displayVariant() {
      if (this.variant === 'wide' && this.isMobileViewport) {
        return 'default'
      }
      return this.variant
    },
    isBeingVerify() {
      const client = this.client
      return !!(client && client.beingVerify)
    },
    hasPodftError() {
      const podft = this.client && this.client.podft
      return !!(podft && podft.success === false)
    },
    cardClasses() {
      const isSidebar = this.displayVariant === 'sidebar'
      return [
        isSidebar ? 'client-card--sidebar' : '',
        this.isBeingVerify ? 'pulse' : '',
        !isSidebar && this.hasDangerBorder ? 'border-danger' : ''
      ]
    },
    hasDangerBorder() {
      const missingKdp = !this.client.filter.verify && this.client.filter.resident
      return missingKdp || this.hasPodftError
    },
    clientName() {
      return this.module.Client.clientName(this.client.client)
    },
    clientTitle() {
      return this.client.client.title ? this.client.client.title : this.clientName
    },
    formattedIin() {
      const iin = this.client?.client?.iin || ''
      const digitsOnly = String(iin).replace(/\s+/g, '')
      return digitsOnly.replace(/(.{3})/g, '$1 ').trim()
    },
    personTypeLabel() {
      const isPerson = this.client?.filter?.person
      if (this.isMobileViewport) {
        return isPerson ? 'ФЛ' : 'ЮЛ'
      }
      return isPerson ? 'Физ. лицо' : 'Юр. лицо'
    },
    residentTypeLabel() {
      const isResident = this.client?.filter?.resident
      if (this.isMobileViewport) {
        return isResident ? 'Рез.' : 'Нерез.'
      }
      return isResident ? 'Резидент' : 'Нерезидент'
    },
    pensionerLabel() {
      if (this.isMobileViewport) {
        return this.client?.client?.pensioner ? 'Л' : ''
      }
      return this.client?.client?.pensioner ? 'Льгота' : ''
    }
  },
  mounted() {
    this.mobileMediaQuery = window.matchMedia('(max-width: 767.98px)')
    this.isMobileViewport = this.mobileMediaQuery.matches
    this.onMobileViewportChange = (event) => {
      this.isMobileViewport = event.matches
    }
    this.mobileMediaQuery.addEventListener('change', this.onMobileViewportChange)
  },
  beforeUnmount() {
    this.mobileMediaQuery?.removeEventListener('change', this.onMobileViewportChange)
  }
}
</script>
